var _rect, _text, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMsme(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#ffffff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 33,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
    fontWeight: 800,
    fontSize: 19,
    letterSpacing: -0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#1a5fb4"
  }, "MS"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#2ec27e"
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#1a5fb4"
  }, "E"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 45,
    width: 36,
    height: 3,
    rx: 1.5,
    fill: "#2ec27e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMsme);
export default __webpack_public_path__ + "static/media/icon-msme.8c184753f0ec0301b05ecd5b8b236254.svg";
export { ForwardRef as ReactComponent };